/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { TextState } from './types';
import { RootState } from '../types';

export const state: TextState = {
  news: {
    error: undefined,
    data: undefined,
    status: undefined,
  },
};

const namespaced = true;

export const textPage: Module<TextState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
